(() => {
  const init = () => {
    const root = document.querySelector('[data-dhuni-search-page]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const { matches, escapeHtml: escape, loadCatalog } = window.DhuniSearch;
    const form = root.querySelector('form');
    const query = form.querySelector('[name="q"]');
    const tags = [...form.querySelectorAll('[data-search-filter]')];
    const min = form.querySelector('[data-search-price-min]');
    const max = form.querySelector('[data-search-price-max]');
    const stock = form.querySelector('[data-dhuni-search-stock-toggle]');
    const sort = form.querySelector('[data-search-sort]');
    const status = root.querySelector('[data-dhuni-search-count]');
    const grid = root.querySelector('#ProductGridContainer');
    const more = root.querySelector('[data-search-more]');
    const retry = root.querySelector('[data-search-retry]');
    let catalog;
    let shown = 24;
    const restore = () => {
      const params = new URLSearchParams(window.location.search);
      query.value = params.get('q') || '';
      tags.forEach((select) => {
        select.value = params.getAll('dhuni_tag').find((tag) => [...select.options].some((option) => option.value === tag)) || '';
      });
      if (min) min.value = params.get('dhuni_min') || '';
      if (max) max.value = params.get('dhuni_max') || '';
      // 最初はオフ（売り切れも表示）。オンにしたときだけ URL に残す（2026-10-10）
      stock.checked = params.get('dhuni_stock') === 'in';
      if (sort) sort.value = params.get('dhuni_sort') || 'created-descending';
    };
    const state = () => ({
      query: query.value.trim(), tags: tags.map((select) => select.value).filter(Boolean),
      minPrice: min?.value ? Number(min.value) : null,
      maxPrice: max?.value ? Number(max.value) : null,
      inStockOnly: stock.checked,
    });
    const save = () => {
      const value = state();
      const url = new URL(window.location.href);
      // Keep preview/localization parameters, but discard the old standard-search filters.
      [...url.searchParams.keys()].forEach((key) => {
        if (key.startsWith('filter.') || key.startsWith('dhuni_') || ['page', 'sort_by', 'options[prefix]'].includes(key)) url.searchParams.delete(key);
      });
      url.searchParams.set('q', value.query);
      url.searchParams.set('type', 'product');
      value.tags.forEach((tag) => url.searchParams.append('dhuni_tag', tag));
      if (value.minPrice != null) url.searchParams.set('dhuni_min', value.minPrice);
      if (value.maxPrice != null) url.searchParams.set('dhuni_max', value.maxPrice);
      if (stock.checked) url.searchParams.set('dhuni_stock', 'in');
      if (sort?.value) url.searchParams.set('dhuni_sort', sort.value);
      if (url.href !== window.location.href) window.history.pushState({}, '', url);
    };
    const onSale = (item) => item.available && item.compare_at_price > item.price;
    // 売り切れと、価格が入っていない商品（0 で登録された SOLDOUT 掲載）は価格を出さない。price.liquid と同じ規則。
    const hasPrice = (item) => item.available && item.price > 0;
    const card = (item) => `<li class="grid__item"><div class="card-wrapper product-card-wrapper underline-links-hover">
      <div class="card card--standard card--media"><div class="card__inner ratio" style="--ratio-percent:100%">
        <div class="card__media"><div class="media media--transparent">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.title)}" width="540" height="540" loading="lazy">` : ''}</div></div>
        ${onSale(item) ? '<div class="card__badge top right card__badge--sale"><span class="badge">OPENSALE</span></div>' : ''}
      </div><div class="card__content"><div class="card__information"><h2 class="card__heading h5"><a class="full-unstyled-link" href="${escape(item.url)}">${escape(item.title)}</a></h2>
      ${item.origin ? `<p class="card__origin">産地：${escape(item.origin)}</p>` : ''}
      <div class="price${onSale(item) ? ' price--on-sale' : ''}">${!hasPrice(item) ? ''
        : onSale(item)
        ? `<div class="price__sale"><span class="visually-hidden">通常価格</span><s class="price-item price-item--regular">${escape(item.compare_at_price_display)}</s><span class="visually-hidden">セール価格</span><span class="price-item price-item--sale">${escape(item.price_display)}</span></div>`
        : `<span class="price-item price-item--regular">${escape(item.price_display)}</span>`}</div>${item.available ? '' : '<span class="badge">売り切れ</span>'}</div></div></div></div></li>`;
    const render = () => {
      if (!catalog) return;
      const value = state();
      if (value.minPrice != null && value.maxPrice != null && value.minPrice > value.maxPrice) {
        status.textContent = '最低価格は最高価格以下にしてください。';
        grid.innerHTML = ''; more.hidden = true; return;
      }
      const items = catalog.filter((item) => matches(item, value));
      const order = sort?.value || 'created-descending';
      items.sort((a, b) => {
        // どの並び順でも在庫ありを先に（2026-10-10 ユーザー判断）
        if (a.available !== b.available) return a.available ? -1 : 1;
        if (order === 'price-ascending') return a.price - b.price;
        if (order === 'price-descending') return b.price - a.price;
        if (order === 'created-descending') return Number(b.created) - Number(a.created);
        return a.title.localeCompare(b.title, 'ja');
      });
      status.textContent = items.length ? `${items.length}件見つかりました` : '条件に合う商品が見つかりませんでした。';
      grid.innerHTML = `<ul class="grid product-grid grid--${root.dataset.columnsMobile}-col-tablet-down grid--${root.dataset.columnsDesktop}-col-desktop" role="list">${items.slice(0, shown).map(card).join('')}</ul>`;
      more.hidden = items.length <= shown;
      more.textContent = `もっと見る（残り${Math.max(0, items.length - shown)}件）`;
    };
    const update = () => { shown = 24; save(); render(); };
    // Register before loading so submitting while a request is pending cannot leave this search.
    form.addEventListener('submit', (event) => { event.preventDefault(); update(); });
    form.addEventListener('change', update);
    more.addEventListener('click', () => { shown += 24; render(); });
    window.addEventListener('popstate', () => { restore(); shown = 24; render(); });
    const load = async () => {
      retry.hidden = true;
      grid.setAttribute('aria-busy', 'true');
      // The loading spinner inside #ProductGridContainer already shows this message visually;
      // leave the status region empty here so it isn't repeated on screen.
      try { catalog = await loadCatalog(); render(); }
      catch { status.textContent = '商品を読み込めませんでした。更新してください。'; retry.hidden = false; }
      finally { grid.setAttribute('aria-busy', 'false'); }
    };
    retry.addEventListener('click', load);
    restore();
    load();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
